import { createContext, useContext } from 'react';

const QuickCatchupContext = createContext();

export const useQuickCatchup = () => useContext(QuickCatchupContext);
 
export default QuickCatchupContext; 